const CompanyRating = {
  id: '',
};



export default CompanyRating;
